import dynamic from "next/dynamic";
import SquareTagsGridConfig from "./square-tags-grid-config";
import SquareTagsGridAdvancedConfig from "./square-tags-grid-advanced-config";
const SquareTagsGridComponent = dynamic(()=>import("./square-tags-grid-component"));
export default {
    SquareTagsGridComponent,
    SquareTagsGridConfig,
    SquareTagsGridAdvancedConfig
};
